<template>
  <div class="container-fluid mt-2">
    <h1>Service Anfrage</h1>
    <br/>
    <div class="btn-toolbar" role="toolbar">
      <button @click="rework" class="btn btn-secondary" id="rework">Wiederholen</button>
    </div>
    <div class="row mt-3">
      <div class="col-md">
        <div class="card">
          <div class="card-header">Anfrage-Details</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md"><b>ID</b></div>
                <div class="col-md">{{ request.id }}</div>
            </div>
            <div class="row">
              <div class="col-md"><b>Typ</b></div>
                <div class="col-md">{{ request.reqid }}</div>
            </div>
            <div class="row">
              <div class="col-md"><b>Datum</b></div>
                <div class="col-md">{{ request.send }}</div>
            </div>
            <div class="row">
              <div class="col-md"><b>Status</b></div>
                <div class="col-md">{{ request.status }}</div>
            </div>
            <div class="row">
              <div class="col-md"><b>Prozess</b></div>
                <div class="col-md"><router-link :to="'/workflows/history/' + request.procid">{{ request.procid }}</router-link></div>
            </div>
            <div class="row">
              <div class="col-md"><b>Abgeschlossen</b></div>
              <div class="col-md"><font-awesome-icon v-if="request.finished" icon="check"/></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md">
        <div class="card">
          <div class="card-header">Anfrage-Daten</div>
          <div class="card-body">
            <JsonViewer :data="request.data" :root="true"/>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-header">Zusatzinformationen</div>
          <div class="card-body">
            <JsonViewer :data="request.info" :root="true"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/modules/services.js'
import JsonViewer from '@/components/JsonViewer.vue'

export default {
  name: 'ServiceRequestView',
  components: {
    JsonViewer,
  },
  data() {
    return {
      request: { data: {} , info: {}},
    }
  },
  created: function() {
    var self = this;
    services.loadrequest(this,this.$route.params.id,function(data) {
      self.request = data;
    })
  },
  methods: {
    rework() {
      if (this.request.id && confirm('Möchten Sie die Service Anfrage erneut starten?')) {
        var self = this;
        services.reworkrequest(this,this.request.id,function() {
          self.$bvToast.toast('Verarbeitung gestartet.',{title: 'Service Anfrage',variant:'success'});
        })
      }
    }
  }
}
</script>
